(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["contact-form"] && !Shopify.designMode) return;
  try {
    document.addEventListener('submit', function (event) {
    var form = event.target.closest('.corporate-enquiry-form__form');
    if (!form) return;
    var button = form.querySelector('button[type="submit"], input[type="submit"]');
    if (button) {
      button.setAttribute('aria-busy', 'true');
      button.disabled = true;
      var originalText = button.textContent;
      button.dataset.originalText = originalText;
      button.textContent = 'Sending…';
    }
  });
  } catch(e) { console.error(e); }
})();

})();
